import type { JSX } from 'react'
import type { ILabelProps } from '../Label'

import { COLOR } from 'vars/index'
import { Label } from '../Label'
import { Backgrounds, Corners, Fonts, Paddings } from '../Label.h'

export type ILabelContentBadgeProps = ILabelProps

/**
 * Light pill for a WBS content label, such as the "New Movie" badge above the
 * title of the content details banner.
 */
export const LabelContentBadge = ({
  background = Backgrounds.TEXT_ICON_PRIMARY,
  color = COLOR.TEXT_ICON_CONSTANT_DARK,
  corners = Corners.CORNERS_10,
  font = Fonts.FontXsBold,
  padding = Paddings.SIZE_90,
  ...rest
}: ILabelContentBadgeProps): JSX.Element => (
  <Label
    background={background}
    color={color}
    corners={corners}
    font={font}
    padding={padding}
    {...rest}
  />
)
